var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discover-light-large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card_bg",
    d: "M32 2.66667V18.6667C32 20.1394 30.8061 21.3333 29.3333 21.3333H2.66667C2.35722 21.3357 2.04995 21.2815 1.76 21.1733C0.70414 20.7916 0.000477693 19.7894 0 18.6667V2.66667C0 1.19391 1.19391 0 2.66667 0H29.3333C30.8061 0 32 1.19391 32 2.66667Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "discover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32.0026 10.6667V18.6431C32.0026 20.1288 30.7918 21.3333 29.2983 21.3333H2.2554C1.94159 21.3356 1.62998 21.2809 1.33594 21.1719C3.60754 20.849 5.79802 20.4455 7.94793 19.9882C8.51583 19.8806 9.07021 19.7461 9.62459 19.625C18.5623 17.5939 26.2965 14.6078 30.6505 11.6755C31.1372 11.3392 31.597 11.0029 32.0026 10.6667Z",
    fill: "#EE7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66797 7.09334H3.8813V7.06667C4.81014 6.99949 5.67636 7.53886 6.02589 8.40204C6.37542 9.26523 6.12853 10.2553 5.41464 10.8533C4.97899 11.1946 4.4338 11.3653 3.8813 11.3333H2.66797V7.09334ZM3.72245 10.6667C4.13953 10.7033 4.55353 10.5685 4.86911 10.2933C5.16928 10.0203 5.33899 9.63241 5.33578 9.22667C5.34158 8.82041 5.17142 8.43148 4.86911 8.16C4.54826 7.89645 4.13557 7.77169 3.72245 7.81334H3.50911V10.6667H3.72245Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.57031,
    y: 7.08667,
    width: 0.833333,
    height: 4.28,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.45026 8.72667C8.95026 8.54667 8.78359 8.42 8.78359 8.18667C8.78359 7.95333 9.04359 7.71333 9.40359 7.71333C9.66622 7.72436 9.91041 7.85134 10.0703 8.06L10.5036 7.49333C10.1615 7.18067 9.71369 7.00917 9.25026 7.01333C8.90881 6.99143 8.57325 7.11007 8.32145 7.34173C8.06965 7.57339 7.92351 7.89791 7.91693 8.24C7.91693 8.83333 8.18359 9.13333 8.96359 9.41333C9.16409 9.47756 9.35825 9.56014 9.54359 9.66C9.70073 9.75073 9.79736 9.91855 9.79693 10.1C9.79572 10.2712 9.72302 10.4341 9.59641 10.5493C9.4698 10.6645 9.3008 10.7216 9.13026 10.7067C8.74147 10.7109 8.38645 10.4864 8.22359 10.1333L7.68359 10.6533C7.99873 11.1869 8.58483 11.5005 9.20359 11.4667C9.58839 11.493 9.96651 11.3563 10.2455 11.0899C10.5245 10.8236 10.6786 10.4523 10.6703 10.0667C10.6703 9.38667 10.3969 9.07333 9.45026 8.72667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10.9415 9.22667C10.936 9.82532 11.1732 10.4007 11.599 10.8215C12.0248 11.2423 12.603 11.4727 13.2015 11.46C13.565 11.4622 13.9238 11.3776 14.2482 11.2133V10.2333C13.9963 10.5278 13.6289 10.6981 13.2415 10.7C12.8496 10.7098 12.4714 10.5557 12.198 10.2747C11.9247 9.99376 11.7809 9.61147 11.8015 9.22C11.7889 8.83882 11.9302 8.46861 12.1936 8.19273C12.4569 7.91685 12.8201 7.7585 13.2015 7.75334C13.6033 7.75495 13.9848 7.92991 14.2482 8.23334V7.25334C13.934 7.07916 13.5808 6.98742 13.2215 6.98667C12.6216 6.97956 12.0436 7.21199 11.6156 7.63246C11.1876 8.05293 10.945 8.62671 10.9415 9.22667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M20.8697 9.96L19.7231 7.08667H18.8164L20.6297 11.4733H21.0764L22.9297 7.08667H22.0231L20.8697 9.96Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M23.3008 11.3667H25.6741V10.64H24.1341V9.48667H25.6141V8.76H24.1341V7.81334H25.6741V7.08667H23.3008V11.3667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9771 8.34667C29.0225 8.94691 28.5986 9.4811 28.0038 9.57333L29.3371 11.3333H28.3238L27.1638 9.64H27.0705V11.3333H26.2305V7.09333H27.4571C28.4305 7.09333 28.9771 7.54667 28.9771 8.34667ZM27.0716 9.05333H27.3383C27.8316 9.05333 28.1249 8.88 28.1249 8.42666C28.1249 7.97333 27.8449 7.76 27.3383 7.76H27.0716V9.05333Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M19.0623 9.22667C19.0623 10.4822 18.0445 11.5 16.789 11.5C15.5334 11.5 14.5156 10.4822 14.5156 9.22667C14.5156 7.97114 15.5334 6.95334 16.789 6.95334C18.043 6.957 19.0586 7.97266 19.0623 9.22667Z",
    fill: "#EE7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4128 7.17333C29.4107 7.2191 29.3777 7.25755 29.3328 7.26667L29.4528 7.44H29.3461L29.2261 7.28V7.44H29.1328V7.05333H29.2661C29.3595 7.05333 29.4128 7.09333 29.4128 7.17333ZM29.3204 7.17333C29.3204 7.13333 29.2937 7.13333 29.2537 7.13333V7.21333H29.2671C29.3025 7.21333 29.3154 7.21333 29.3196 7.2073C29.3233 7.202 29.3204 7.19205 29.3204 7.17333Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9766 7.24C28.9764 7.06099 29.1177 6.91383 29.2966 6.90667C29.3873 6.90304 29.4755 6.93655 29.5409 6.99946C29.6064 7.06237 29.6433 7.14924 29.6432 7.24C29.6432 7.4241 29.494 7.57334 29.3099 7.57334C29.1258 7.57334 28.9766 7.4241 28.9766 7.24ZM29.2973 7.52C29.3644 7.52212 29.4286 7.49247 29.4706 7.44C29.5206 7.3852 29.549 7.31415 29.5506 7.24C29.5506 7.10009 29.4372 6.98667 29.2973 6.98667C29.1574 6.98667 29.0439 7.10009 29.0439 7.24C29.0384 7.31121 29.0624 7.38155 29.1104 7.43451C29.1583 7.48747 29.2259 7.51838 29.2973 7.52Z",
    fill: "#231F20"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.8616d5ea98d9e7a7f8047fcab40f54af.svg";
export { ForwardRef as ReactComponent };